module.exports = __webpack_public_path__ + "static/media/line.e0f9020d.svg";